module.exports = __webpack_public_path__ + "img/map_suite-locations_classic-seasons.a82745b8.jpg";